/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowUpRhombus = createReactComponent("outline", "arrow-up-rhombus", "IconArrowUpRhombus", [["path", { "d": "M12 16v-13", "key": "svg-0" }], ["path", { "d": "M15 6l-3 -3l-3 3", "key": "svg-1" }], ["path", { "d": "M14.5 18.5l-2.5 2.5l-2.5 -2.5l2.5 -2.5z", "key": "svg-2" }]]);

export { IconArrowUpRhombus as default };
//# sourceMappingURL=IconArrowUpRhombus.mjs.map
